export const BroadcastIcon = ({
  size = 16,
  color = '#2D253F',
  className = '',
}: {
  size?: number
  color?: string
  className?: string
}) => (
  <svg
    viewBox="0 0 512 512"
    width={size}
    height={size}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Central Circle */}
    <circle cx="256" cy="256" r="64" fill={color} />

    {/* Inner Waves */}
    <path
      d="M171 341a144 144 0 0 1 0-170"
      stroke={color}
      strokeWidth="48"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M341 171a144 144 0 0 1 0 170"
      stroke={color}
      strokeWidth="48"
      strokeLinecap="round"
      fill="none"
    />

    {/* Outer Waves */}
    <path
      d="M85 427a256 256 0 0 1 0-342"
      stroke={color}
      strokeWidth="48"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M427 85a256 256 0 0 1 0 342"
      stroke={color}
      strokeWidth="48"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
)
